import { render, staticRenderFns } from "./GenericPagination.vue?vue&type=template&id=6acd4f36&"
import script from "./GenericPagination.vue?vue&type=script&lang=js&"
export * from "./GenericPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports